import { render, staticRenderFns } from "./ConstructorsTableHead.vue?vue&type=template&id=039c0215&"
import script from "./ConstructorsTableHead.vue?vue&type=script&lang=js&"
export * from "./ConstructorsTableHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports